import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import { ProviderType } from 'src/types/provider';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import Switch from 'src/components/Switch';
import { SelectValueType } from 'src/components/Select';
import { OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';
import CarrierServiceCodesPicker from './CarrierServiceCodesPicker';

export interface TransportPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: ProviderType;
    disableEdit: boolean;
    serviceCodes: ConstantsCodeType[];
    shipperCodes: ConstantsCodeType[];
    selectedServiceCodes: SelectValueType[];
    setSelectedServiceCodes: React.Dispatch<React.SetStateAction<SelectValueType[]>>;
}

const Transport: FC<TransportPropsType> = (props) => {
    return (
        <Grid>
            <GridItem cols={4}>
                <Switch
                    value={!!props.editData.DEFAULT_ALLOW_EXPEDITION}
                    onChange={(value) => props.onChange('DEFAULT_ALLOW_EXPEDITION', value ? 1 : 0, false)}
                    disabled={props.disableEdit}
                    label={translate('providerDetail.allowExpedition')}
                />
            </GridItem>
            <GridItem cols={4}>
                <Switch
                    value={!!props.editData.SEND_RECIPIENT_EMAIL_B2C_ON_THE_WAY}
                    onChange={(value) => props.onChange('SEND_RECIPIENT_EMAIL_B2C_ON_THE_WAY', value ? 1 : 0, false)}
                    disabled={props.disableEdit}
                    label={translate('providerDetail.sendRecipientEmailB2CSend')}
                />
            </GridItem>
            <GridItem cols={4}>
                <Switch
                    value={!!props.editData.SEND_RECIPIENT_EMAIL_B2B_ON_THE_WAY}
                    onChange={(value) => props.onChange('SEND_RECIPIENT_EMAIL_B2B_ON_THE_WAY', value ? 1 : 0, false)}
                    disabled={props.disableEdit}
                    label={translate('providerDetail.sendRecipientEmailB2BSend')}
                />
            </GridItem>
            <GridItem cols={12}>
                <CarrierServiceCodesPicker
                    serviceCodes={props.serviceCodes}
                    shipperCodes={props.shipperCodes}
                    selectedServiceCodes={props.selectedServiceCodes}
                    setSelectedServiceCodes={props.setSelectedServiceCodes}
                    disabled={props.disableEdit}
                />
            </GridItem>
        </Grid>
    );
};

export default Transport;
